import "./App.css";
import Sidebar from "./components/Sidebar";
import Profile from "./components/Profile";
import Right from "./components/Right";
import Home from "./components/Home";
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";
import React, { useEffect, useState } from "react";

function App() {
  const [homeActive, setHomeActive] = useState("");

  return (
    <Router>
      <div className="app">
        <Sidebar />
        <div className="main">
          <Switch>
            <Route path="/realdonaldtrump">
              <Profile />
            </Route>

            <Route path="/">
              <Home />
            </Route>
          </Switch>
        </div>

        <Right />
      </div>
      <div className="nav">
        <div className={"navIcon " + homeActive}>
          <Link to="/">
            <i class="bi bi-house-door-fill"></i>
          </Link>
        </div>
        <div className="navIcon">
          <i class="bi bi-search"></i>
        </div>
        <div className="navIcon">
          <i class="bi bi-bell"></i>
        </div>
        <div className="navIcon">
          <i class="bi bi-envelope"></i>
        </div>
      </div>
    </Router>
  );
}

export default App;
